module.exports = __webpack_public_path__ + "img/needs.8b4de2a8.svg";